export default __webpack_public_path__ + "static/media/Leaders_IMG-Leader-04A.26aa141d.png";